module.exports = __webpack_public_path__ + "static/media/home-tab.8d9fb29a.png";